module.exports = __webpack_public_path__ + "static/media/7pic.44cc5abf.jpg";